import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { FontelloIcon } from '@sport1/react-elements'

type VideoLabelProps = {
    padding?: number
    margin?: number
    iconSize: 'S' | 'M'
}

const VideoLabel = ({ padding = 2, margin = 3, iconSize }: VideoLabelProps): ReactElement => {
    return (
        <Grid
            noExpand
            position="absolute"
            bottom={0}
            right={0}
            padding={padding}
            margin={margin}
            borderRadius={1}
            backgroundColor="onyx"
        >
            <FontelloIcon
                name="play-with-circle"
                color="moon-3"
                fontSize={iconSize === 'S' ? 14 : 16}
                lineHeight={1}
            />
        </Grid>
    )
}

export default VideoLabel
